import React from 'react'

import RecipesSearchLayout, {
  recipesSearchGetLayout,
} from '@mindfulchefuk/layouts/RecipesSearchLayout'

const Recipes = () => {
  return (
    <RecipesSearchLayout
      mainSection={
        <>
          <h1>Healthy recipes</h1>
          <p>
            Welcome to our healthy recipe library. Here you’ll find our full
            range of over 800 delicious recipes, completely free for you to
            browse, cook and enjoy. If you are looking for healthy recipe
            inspiration, you&apos;ve come to the right place.
          </p>
        </>
      }
      secondarySection={
        <>
          <h2>About our meals</h2>
          <p>
            All of our healthy meals are 100% gluten-free. With no stodgy carbs
            you can be assured all of our recipes are the perfect accompaniment
            to a healthy lifestyle. We use only the best ingredients. To ensure
            this we work closely with small family-run British farms to have
            complete transparency over Quality and Sustainability.
            <br />
            <br />
            Whether you live alone, are in a couple or have a family, our
            healthy recipes can help make meals times that little bit easier.
            Use the filter to see the variety of recipes on offer allowing you
            to whip up a tasty home cooked meal every day without ever having to
            worry.
            <br />
            <br />
            We&apos;ve done all the hard work so you don&apos;t have to! Let us
            help fuel your health goals, with nutritious, delicious meals.
          </p>
        </>
      }
    />
  )
}

Recipes.getLayout = recipesSearchGetLayout({
  metaTitle: 'Healthy Recipes',
  metaDescription:
    "Browse over 800 healthy recipes curated to bring a balanced diet to all the family. Meat lovers, vegans, fish enthusiasts. We've got you covered.",
  metaCanonicalPath: 'recipes',
})

export default Recipes

export { getStaticGlobalContent as getStaticProps } from '@mindfulchefuk/features/CMS/services/getStaticData'
